import React from "react";
import useUser from "../../../../hooks/super/useUser";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function DeleteUserModal({ open, handleClose, uid, userName, removeFlag, adminFlag }) {
  const { deleteUser, deleteAdmin } = useUser();
  const [busy, setBusy] = React.useState(false);

  const list = Array.isArray(userName) ? userName : [];
  const subjects = adminFlag ? "administrator" : "user";
  const plural = list.length > 1 ? "s" : "";
  const title = removeFlag
    ? `Permanently remove ${subjects}${plural}?`
    : `Delete ${subjects}${plural}?`;
  const body = removeFlag
    ? `This will permanently remove the selected ${subjects}${plural} and cannot be undone.`
    : `The selected ${subjects}${plural} will be marked deleted. You can restore them later.`;

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (adminFlag) await deleteAdmin(uid, removeFlag);
      else await deleteUser(uid, removeFlag);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="danger"
      title={title}
      body={body}
      items={list.map((u) => ({ id: u.id, title: u.email }))}
      submitLabel={removeFlag ? "Remove permanently" : "Delete"}
      loading={busy}
    />
  );
}

export default DeleteUserModal;
